import { useEffect } from "react"

export const useClickOutside = (containerRef, callback) => {
  useEffect(() => {
    const handleClickOutside = (e) => containerRef.current && !containerRef.current.contains(e.target) && callback()
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])
}
